"use strict";
import {
  createApp
} from "vue";
export function mountVueApp(component, selector, configure) {
  const app = createApp(component);
  configure?.(app);
  return app.mount(selector);
}
